import { render, staticRenderFns } from "./AlertConfirmDialog.vue?vue&type=template&id=bfc8dcd0&scoped=true&"
import script from "./AlertConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./AlertConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertConfirmDialog.vue?vue&type=style&index=0&id=bfc8dcd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc8dcd0",
  null
  
)

export default component.exports